import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { create } from './utils';

export default function* listenAddPayout() {
  yield takeEvery(payoutActions.addPayout.toString(), create);
}
